import '../../../../bower_components/fastclick/lib/fastclick';
import 'autotrack';
import $ from 'jquery';
window.$ = window.jQuery = $;

import config from './config';
import _ from 'underscore';
import Backbone from 'backbone';
import loadThirdPartyJs from './utils/third_party_util';
import ads from './services/admanager';
import legacyGlobals from './utils/legacy-globals';
import cookieUtil from 'js-cookie';
import 'picturefill';
Backbone.$ = $;
Backbone._ = _;
let bulk = require('bulk-require');
import router from './services/router_service';
bulk(__dirname, [
    './routes/*.js'
]);

// Globals need to happen before document ready
legacyGlobals();
const startApp = () => {
    // initializing lazyload lib with config object. edgeY is the distance from viewport before the call is made to retrieve the asset

    $(() => {
        Backbone.history.start({
            root: '/',
            pushState: true,
            silent: false
        });

        const urlParts = window.location.pathname.split('/');

        if (urlParts[1] !== 'embed') {
            router.trigger('route:common');
        }

        ads();

        // @Mezzobit - feel free to move this to your UI :)
        loadThirdPartyJs();
        config.setinitialPageLoad();
    });
};

if (cookieUtil('fc_auth')) {
    config.authCheck().then(() => {
        startApp();
    });
} else {
    startApp();
}
